import { useOrderPanelStore } from '../../stores/order-panel-store'

/**
 * Buiten-werkgebied toeslag (gerenderd door OrderComposer, alleen zichtbaar
 * in buiten-werkgebied modus). Toont het toeslag-percentage dat in de prijs
 * wordt verrekend — default komt uit de DPA van het vaste 'Buiten
 * werkgebied'-gebied; kantoor kan het per situatie aanpassen (afstand,
 * opdrachtgrootte). Een afwijkende waarde gaat als Actie_Code__c='TOESLAG:<int>'
 * mee bij het aanmaken zodat de SF-reprice exact dezelfde prijs rekent als
 * hier getoond.
 */
export function ToeslagControl() {
  const buitenWerkgebied = useOrderPanelStore((s) => s.buitenWerkgebied)
  const bootstrapRaw = useOrderPanelStore((s) => s.bootstrapRaw)
  const toeslagOverridePct = useOrderPanelStore((s) => s.toeslagOverridePct)
  const setToeslagOverride = useOrderPanelStore((s) => s.setToeslagOverride)

  if (!buitenWerkgebied) return null

  const defaultPct = bootstrapRaw?.regioToeslagPercentage ?? 0
  const effectivePct = toeslagOverridePct ?? defaultPct

  return (
    <div className="space-y-1.5">
      <label className="flex items-center gap-2 text-sm">
        <span className="font-medium">Toeslag buiten werkgebied</span>
        <input
          type="number"
          min={0}
          max={100}
          value={effectivePct}
          onChange={(e) => {
            const v = e.target.value
            if (v === '') {
              setToeslagOverride(null)
              return
            }
            const parsed = Number(v)
            setToeslagOverride(Number.isFinite(parsed) ? parsed : null)
          }}
          className="w-20 px-2 py-1.5 border border-slate-200 rounded-md text-sm text-right focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
        <span className="text-slate-600">%</span>
        {toeslagOverridePct !== null && toeslagOverridePct !== defaultPct && (
          <button
            type="button"
            onClick={() => setToeslagOverride(null)}
            className="text-xs text-indigo-600 hover:underline"
          >
            Terug naar standaard ({defaultPct}%)
          </button>
        )}
      </label>
      <p className="text-xs text-slate-500">
        Wordt verrekend in de getoonde prijs en op de offerte/order — pas aan op
        afstand of situatie.
      </p>
    </div>
  )
}
